var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBolt = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 16,
  viewBox: "0 0 17 16",
  fill: "none",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_1896_1840",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 17,
  height: 16
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  width: 16,
  height: 16,
  fill: "inherit"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1896_1840)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.7832 11.85L10.8332 8.00002H8.34987L8.7832 4.31668L5.89987 8.80002H8.3332L7.7832 11.85ZM7.28454 9.66668H5.22304C5.03237 9.66668 4.89326 9.58418 4.8057 9.41918C4.71804 9.25429 4.72254 9.09107 4.8192 8.92952L8.72037 2.74502C8.78793 2.61935 8.88581 2.53896 9.01404 2.50385C9.14215 2.46885 9.27031 2.47274 9.39854 2.51552C9.52676 2.55818 9.62848 2.63635 9.7037 2.75002C9.77893 2.86368 9.80754 2.99018 9.78954 3.12952L9.3217 7.13335H11.5922C11.7964 7.13335 11.9417 7.22313 12.028 7.40268C12.1144 7.58213 12.0969 7.75263 11.9755 7.91418L7.69604 13.382C7.61059 13.4855 7.50654 13.5541 7.38387 13.5879C7.2612 13.6215 7.1392 13.608 7.01787 13.5474C6.89654 13.4867 6.80487 13.3995 6.74287 13.2859C6.68087 13.1722 6.66443 13.0512 6.69354 12.923L7.28454 9.66668Z",
  fill: "#A20066"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBolt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bolt.96a4c4e6a16de62d4125050fb5e6def1.svg";